import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Applicant, IDVData } from '@shared/models/data-model';
import { IdvService } from '@shared/services/idv.service';
import { RegistrationService } from '@shared/services/registration.service';

export interface ApplicantPreIdvData {
    applicant: Applicant;
    idvData: IDVData[];
}

export const applicantPreIdvResolver: ResolveFn<ApplicantPreIdvData> = async (route, state) => {
    const registrationService = inject(RegistrationService);
    const idvService = inject(IdvService);
    const applicant = await registrationService.getApplicant();
    const idvData = await idvService.loadApplicationIDVData(applicant.contactId).catch(() => null);
    return {
        applicant: applicant,
        idvData: idvData
    }
};
